;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { ReactNode } from 'react';
import Button, { Type } from './Button';

type Props = {
  children: ReactNode;
  type: Type;
  href: string;
  className?: string;
  arrow?: boolean;
};

export default function LinkButton({ children, type, href, className, arrow = false }: Props) {
  return (
    <Link tabIndex={-1} className="text-decoration-none" href={href} style={{ width: 'fit-content' }}>
      <Button className={className} type={type} arrow={arrow}>
        {children}
      </Button>
    </Link>
  );
}
